import { Flex, Icon, Text } from '@chakra-ui/react'
import { Td, Tr } from '../../components/Table'
import { ModalContatos } from './ModalContatos'
import { formatPrice } from '../../utils/formatPrice'
import { FaWhatsapp } from 'react-icons/fa'
import { Telefone } from './components/Telefone'

export function Item({ data, odd }) {
  return (
    <Tr border="none">
      <Td
        borderRight="1px solid #CFCFCF"
        bgColor={odd ? '#EDF2F7' : 'white'}
        py={3}
      >
        <Flex gap={2} alignItems="center" justifyContent="space-between">
          <Text maxW="fit-content" isTruncated>
            {data?.nome_cliente}
          </Text>
          <ModalContatos
            list={data?.info_contato}
            cliente={data?.nome_cliente}
          />
        </Flex>
      </Td>

      <Td
        py={0}
        borderRight="1px solid #CFCFCF"
        bgColor={odd ? '#EDF2F7' : 'white'}
      >
        {data.quantidade_pedido}
      </Td>
      <Td py={0} bgColor={odd ? '#EDF2F7' : 'white'}>
        {formatPrice(data.valor_total)}
      </Td>
    </Tr>
  )
}
